<template>
  <div class="page">
    <div class="container">
      <ul class="link-list">
        <li @click="go('/intro')">
          <img src="@/assets/images/zplab/icon_intro.png" alt="">
          지피테라퓨틱스 소개
        </li>
        <li @click="go('/actinum')">
          <img src="@/assets/images/zplab/icon_actinum.png" alt="">
          액티넘 정보
        </li>
        <li @click="go('/lamisil')">
          <img src="@/assets/images/zplab/icon_lamisil.png" alt="">
          라미실 정보
        </li>
        <li @click="go('/betadine')">
          <img src="@/assets/images/zplab/icon_betadine.png" alt="">
          베타딘 정보
        </li>
        <li @click="go('/cyclogest')">
          <img src="@/assets/images/zplab/icon_cyclogest.png" alt="">
          사이클로제스트 정보
        </li>
        <li @click="go('/mr-visit')">
          <img src="@/assets/images/zplab/icon_mrvisit.png" alt="">
          MR 방문 접수
        </li>
      </ul>
      <p class="step-sub-contents text-11">
        본 웹사이트 내 게시물의 저작권 및 소유권은 지피테라퓨틱스에 있으며, 컨텐츠 다운로드, 캡쳐 등 무단 배포 및 외부로의 유출 행위를 금지합니다.
      </p>
    </div>
    <Footer />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Header from "../commonComp/WS-Header.vue";
import Footer from "../commonComp/Footer.vue";
import Cookies from "js-cookie";

const modelService = require("@/utils/dataModel.js");

export default {
  components: {
    Header, Footer
  },
  data() {
    return {
      headTitle: "HOME",
      reqDataModel: modelService.reqDataModel()
    };
  },
  computed: {
    accessInfo() {
      const CookieName = process.env.VUE_APP_CookieName;
      return JSON.parse(Cookies.get(CookieName));
    },
    ...mapGetters(["isAuthorized"]),
  },
  methods: {
    scrollToBenefit() {
      const scrollTarget = document.getElementById('benefit').offsetTop;
      window.scrollTo({ top: scrollTarget, behavior: "smooth" });
    },
    go(route) {
      this.$router.push(route);
    },
    ...mapActions(["getDataQuery", "saveDataQuery"]),
  },
};
</script>
